import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import FeatherIcon from "feather-icons-react";
import {option} from "react-timekeeper/lib/components/styles/time-dropdown";
import FormHandler from "../shared/util/form-handler";
import {toggleConfirmationDialog} from "../shared/actions/setting";
import {validateConfirmationDialog, validateConfirmationDialogNoValidation} from "./form-validation-rules";

const ConfirmationDialog = () => {
  const dispatch = useDispatch();

  const confirmationDialog = useSelector(state => {
    return state.setting.confirmationDialog
  });


  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    handleOnBlur,
    initForm
  } = FormHandler(confirmationSuccess, confirmationDialog && confirmationDialog.showReasonField?validateConfirmationDialog:validateConfirmationDialogNoValidation);


  function hideDialog() {
    dispatch(toggleConfirmationDialog({isVisible: false}));
  }

  function onConfirm() {
    handleSubmit()
  }

  useEffect(() => {
    if (!confirmationDialog || confirmationDialog.isVisible) {
      return;
    }

    initForm({});
  }, [confirmationDialog]);

  function confirmationSuccess() {
    if (confirmationDialog && confirmationDialog.showReasonField) {
      dispatch(toggleConfirmationDialog({isVisible: false, onSuccess: true, reason: values.reason}));
    }else {
      dispatch(toggleConfirmationDialog({isVisible: false, onSuccess: true}));
    }
  }

  return (
    confirmationDialog &&
    <div className={"sa-modal-bg " + (!confirmationDialog.isVisible && 'hide')}>
      <div className="sa-modal-bg-inner">
        <div className="sa-modal-box">
          <div className="container">
            <form onSubmit={handleSubmit} noValidate>
              <div className="sa-modal-header">
                Confirmation
                <div className="sa-modal-close" onClick={hideDialog}><FeatherIcon className={"icon-in-close"}
                                                                                  icon={"x"}/>
                </div>
              </div>
              <div className="sa-modal-content">
                <div
                  className={"warning-heading text-red"}>{confirmationDialog.confirmationHeading || "Are you sure you want to delete this?"}</div>
                <div
                  className={"warning-text"}>{confirmationDialog.confirmationDescription || "The delete action can't be undone and the content will be permanently gone."}
                </div>
              </div>
              {(confirmationDialog.type && confirmationDialog.type == "request") ?
                (<div className="sa-modal-footer">
                  <div className="sa-modal-footer-btn">
                    <button type={"button"} className="btn btn-sa-text w-120p" onClick={hideDialog}>CANCEL</button>
                    <button className="btn btn-sa-danger w-120p">OK</button>
                  </div>
                </div>) :
                (<div className="sa-modal-footer">
                  {confirmationDialog && confirmationDialog.showReasonField &&
                  <div>
                    <div className="form-group m-b-16 col-md-6 deleteReason">
                      <select
                        className={`form-control ${errors.reason && "warning-input"}`}
                        name="reason"
                        value={values.reason || ''}
                        onBlur={handleOnBlur} onChange={handleChange}>
                        <option value={""} hidden>Select the reason</option>
                        {
                          confirmationDialog.reasons.map(item => (
                            <option
                              value={item} key={item}>{item}</option>
                          ))

                        }
                        {/*<option*/}
                        {/*  value={DELETE_REASON.CATEGORY_DEATH}>{DELETE_REASON.CATEGORY_DEATH}</option>*/}
                        {/*<option*/}
                        {/*  value={DELETE_REASON.CATEGORY_INCORRECT_DATA}>{DELETE_REASON.CATEGORY_INCORRECT_DATA}</option>*/}
                        {/*<option*/}
                        {/*  value={DELETE_REASON.CATEGORY_DUPLICATE_DATA}>{DELETE_REASON.CATEGORY_DUPLICATE_DATA}</option>*/}
                        {/*<option*/}
                        {/*  value={DELETE_REASON.CATEGORY_FRAUD}>{DELETE_REASON.CATEGORY_FRAUD}</option>*/}
                        {/*<option*/}
                        {/*  value={DELETE_REASON.CATEGORY_MOVED}>{DELETE_REASON.CATEGORY_MOVED}</option>*/}

                      </select>
                      {errors.reason && (
                        <p className="warning-input-msg ">{errors.reason}</p>)}
                    </div>
                  </div>
                  }
                  <div className="sa-modal-footer-btn">
                    <button className="btn btn-sa-text w-120p" type={"button"} onClick={hideDialog}>CANCEL</button>
                    <button
                      className={confirmationDialog.successButtonClass ? "btn w-120p " + confirmationDialog.successButtonClass : "btn btn-sa-danger w-120p"}
                    >{confirmationDialog.successButtonText || "DELETE"}</button>
                  </div>

                </div>)
              }
            </form>
          </div>

        </div>
      </div>
    </div>


  );

};

export default ConfirmationDialog
